// extracted by mini-css-extract-plugin
export default {"bar":"SearchBar_bar__5IMUs","container":"SearchBar_container__xenQ1","expand":"SearchBar_expand__bJHTi","input":"SearchBar_input__ZMM8m","search":"SearchBar_search__mykX0"};